import { z } from 'zod'

/**
 * 운영 핵심 경보 기준값 (1.0.1) — 첫 실결제 · 생성 실패 급증 · AI 잔액 부족 · 견적 처리 기한 임박.
 * 공개 설정(settings:v1)과 따로 둔다. GET /config 가 settings 를 인증 없이 내보내고,
 * 그 파싱이 깨지면 게스트·플랜 한도까지 기본값으로 돌아가기 때문이다.
 * KV 값이 없거나 깨졌으면 DEFAULT_OPS_ALERT_SETTINGS (보수적인 기본값) 로 돈다.
 */
export const OPS_ALERT_SETTINGS_KV_KEY = 'ops-alerts:v1'

export const opsAlertSettingsSchema = z.object({
  /** RevenueCat 웹훅으로 처음 들어온 실결제 1건 (샌드박스·체험·0원·프로모션 제외). 역사상 첫 1건만 */
  firstPayment: z
    .object({
      enabled: z.boolean().default(true),
    })
    .prefault({}),
  /** 최근 windowMinutes 분 동안 실패 minFailed 건 이상이고 실패율 minRate 이상이면. cooldownHours 동안 다시 안 보낸다 */
  failureSpike: z
    .object({
      enabled: z.boolean().default(true),
      windowMinutes: z
        .number()
        .int()
        .min(10)
        .max(24 * 60)
        .default(60),
      minFailed: z.number().int().min(1).max(1000).default(3),
      minRate: z.number().min(0).max(1).default(0.5),
      cooldownHours: z
        .number()
        .min(1)
        .max(7 * 24)
        .default(6),
    })
    .prefault({}),
  /** OpenRouter 잔액(USD)이 minUsd 이하면. cooldownHours 동안 다시 안 보낸다 */
  aiBalance: z
    .object({
      enabled: z.boolean().default(true),
      minUsd: z.number().min(0).max(100_000).default(20),
      cooldownHours: z
        .number()
        .min(1)
        .max(7 * 24)
        .default(24),
    })
    .prefault({}),
  /**
   * 접수(submitted) 뒤 아직 공장 견적이 없는 요청이 처리 기한(QUOTE_SLA_DAYS) leadHours 시간 전에 들어서면 '임박',
   * 기한을 넘기면 '지연'. 견적·단계마다 한 번. 점검이 매시(C55)라 마감 약 36시간 전에 걸린다 (매일 크론만 남아도 12~36시간 전)
   */
  quoteSla: z
    .object({
      enabled: z.boolean().default(true),
      leadHours: z.number().int().min(1).max(72).default(36),
    })
    .prefault({}),
})
export type OpsAlertSettings = z.infer<typeof opsAlertSettingsSchema>

export const DEFAULT_OPS_ALERT_SETTINGS: OpsAlertSettings = opsAlertSettingsSchema.parse({})
